import TranslationService from "../../services/TranslationService";
import Vue from "vue";

Vue.filter("itemName", function(item, selectedName = App.config.item.itemName, itemDisplayName = App.config.item.displayName)
{
    const { texts: { name1, name2, name3 }, variation: { name, bundleType } } = item;

    // Prüfe auf Property ID 106 für Custom-Name (vorrangig)
    let customName = null;

    if (item.hasOwnProperty("variationProperties"))
    {
        for (let i0 = 0; i0 < item.variationProperties.length; i0++)
        {
            if (item.variationProperties[i0].hasOwnProperty("properties"))
            {
                for (let i = 0; i < item.variationProperties[i0].properties.length; i++)
                {
                    if (item.variationProperties[i0].properties[i].id === 106)
                    {
                        customName = item.variationProperties[i0].properties[i].values.value;
                    }
                }
            }
            else if (item.variationProperties[i0].property && item.variationProperties[i0].property.id === 106)
            {
                customName = item.variationProperties[i0].values.value;
            }
        }
    }

    // Wenn Property 106 gefunden und nicht leer: Custom-Name verwenden
    if (customName !== null && customName.trim() !== "")
    {
        if (bundleType === "bundle")
        {
            return TranslationService.translate("Ceres::Template.itemBundleName", { itemName: customName });
        }
        return customName;
    }

    // Fallback: Normale Name-Logik
    let itemName = "";

    if (selectedName === 1 && name2 !== "")
    {
        itemName = name2;
    }
    else if (selectedName === 2 && name3 !== "")
    {
        itemName = name3;
    }
    else
    {
        itemName = name1;
    }

    if (itemDisplayName === "itemNameVariationName" && name && name.length)
    {
        itemName = `${itemName} ${name}`;
    }

    if (itemDisplayName === "variationName" && name && name.length)
    {
        itemName = name;
    }

    if (bundleType === "bundle")
    {
        itemName = TranslationService.translate("Ceres::Template.itemBundleName", { itemName });
    }

    return itemName;
});
